/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Stale_VerificationInputs */

const cs_enum_stale_verification = /** @type {(inputs: Enum_Stale_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověření zastaralé`)
};

const en_enum_stale_verification = /** @type {(inputs: Enum_Stale_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification stale`)
};

/**
* | output |
* | --- |
* | "Verification stale" |
*
* @param {Enum_Stale_VerificationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_stale_verification = /** @type {((inputs?: Enum_Stale_VerificationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Stale_VerificationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_stale_verification(inputs)
	return cs_enum_stale_verification(inputs)
});